<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <table class="nav_top chatanalytics"><!-- //NOSONAR -->
    <tr>
      <td v-if="isC1Interactions" class="nav_top_calabrio"><span>Trending Topics</span></td>
      <td v-else-if="isC1BotAnaltyics" class="nav_top_calabrio"><span>Bot Analytics</span></td>
      <td v-else-if="isC1AutoQA" class="nav_top_calabrio"><span>Auto QM</span></td>
      <td v-else-if="isC1SmartTags" class="nav_top_calabrio"><span>AI Tags</span></td>
      <td v-else class="nav_top_logo"></td>
      <td class="nav_top_bar" v-if="this.$store.getters.isLoggedIn">
        <table><!-- //NOSONAR -->
        <tr>
          <td class="page">
            <div v-for="(component, index) in currentFilterComponents" :key="index" class="component" :class="component.name" align="right">
              <keep-alive>
                <component :is="component.name" :ref="component.name" v-bind="component.properties"></component>
              </keep-alive>
            </div>
            <div v-if="isProcessListDrawerAllowed" class="component process" align="right" :data-testid="generateBranding()?generateBranding()+'-TopMenu-ProcessList':undefined">
              <el-badge :value="0" :hidden="!hasNew" class="item">
                <span class="process-icon" @click="showProcessListDrawer"><i class="el-icon-bell" title="Notifications"></i><!-- //NOSONAR --></span>
              </el-badge>
            </div>
            <div v-if="showAccountMenu" class="component account" align="right">
              <account-widget />
            </div>
          </td>
        </tr>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DateFilterWidget from '../components/widgets/wy-header-menu-date-filter';
  import FilteringWidget from '../components/widgets/wy-header-menu-filtering';
  import LanguagesWidget from '../components/widgets/wy-header-menu-languages';
  import InteractionsTasksWidget from '../components/interactions/widgets/wy-header-menu-task';
  import InteractionsFilteringWidget from '../components/interactions/widgets/wy-header-menu-filtering';
  import ActionWidget from '../components/widgets/wy-header-menu-action';
  import AccountWidget from '../components/widgets/wy-header-menu-account'
  
  import BrandsWidget from '../components/widgets/wy-header-menu-brands';
  import PlatformWidget from '../components/widgets/wy-header-menu-platform';
  import DirectionWidget from '../components/interactions/widgets/wy-header-menu-direction';
  import SpeakersWidget from '../components/smartTag/widgets/wy-header-menu-speakers';
  import FormFilterWidget from '../components/widgets/wy-header-menu-form-filter';
  import MoreFiltersWidget from '../components/interactions/widgets/wy-header-menu-more-filters.vue';
  import ContactTypesWidget from '../components/interactions/widgets/wy-header-menu-contact-type.vue';
  
  
  export default {
    name: 'NavTop',
    components: {
      'date-widget': DateFilterWidget,
      'action-widget': ActionWidget,
      'filtering-widget': FilteringWidget,
      'languages-widget':LanguagesWidget,
      'account-widget' : AccountWidget,
      'brands-widget': BrandsWidget,
      'platform-dropdown-widget': PlatformWidget,
      'tasks-dropdown-widget': InteractionsTasksWidget,
      'interactions-filtering-widget': InteractionsFilteringWidget,
      'interactions-more-filters-widget': MoreFiltersWidget,
      'direction-dropdown-widget': DirectionWidget,
      'speakers-dropdown-widget': SpeakersWidget,
      'form-filter-dropdown-widget': FormFilterWidget,
      'contactTypes-dropdown-widget': ContactTypesWidget,
    },

    watch: {
      updatedProcessList() {
        for(const process of this.updatedProcessList) {
          this.processFinishedAlert(process);
        }

        // if there is finished process, relaod the current page
        if(this.updatedProcessList.find(process => process.processStatus == "finished")) {
          setTimeout(() => {
            this.$router.push({ name: "reload", params: {reload: this.$route.path}});
          }, 300);
        }
      }
    },

    computed: {
      ...mapGetters(['isC1Auth', 'isC1BotAnaltyics', 'isC1Interactions', 'isC1AutoQA', 'isC1SmartTags', 'config', 'dataModel', 'isRoleAllow', 'processNewCounter', 'alertNewCounter', 'updatedProcessList']),

      showAccountMenu() {
        return (!this.isC1Auth);
      },

      currentFilterComponents(){
        /* OC-1452: render all filters regardless of noAvailableData */
        return this.$route.meta.headerMenuItems;
        // if(this.$route.meta.headerMenuItems && this.noAvaliableData) {
        //   let components = this.$route.meta.headerMenuItems.filter(el => (el.name != 'filtering-widget' && el.name != 'platform-dropdown-widget'))
        //   return components
        // }
        // else {
        //   return this.$route.meta.headerMenuItems;
        // }
      },

      hasNew() {
        return this.processNewCounter>0 || this.alertNewCounter>0;
      },

      isProcessListDrawerAllowed() {
        if(this.isC1BotAnaltyics) {
          return this.isRoleAllow([900005, 900009, 900013]);
        }
        else if(this.isC1Interactions) {
          return this.isRoleAllow([4601, 4604]);
        }
        else if(this.isC1AutoQA) {
          return this.isRoleAllow([4704]);
        }
        else if(this.isC1SmartTags) {
          return this.isRoleAllow([4903]); // has permission of SmartTagANotificationView
        }
        else {
          return this.isRoleAllow([3001, 4201])
        }
      }
    },

    methods: {
      handleGotoHome() {
        this.$router.push('/');
      },

      generateBranding() {
        if(this.isC1BotAnaltyics) {
          return 'BotAnalytics';
        }
        else if(this.isC1Interactions) {
          return 'TrendingTopics';
        }
        else if(this.isC1AutoQA) {
          return 'AutoQM';
        }
        else if(this.isC1SmartTags) {
          return 'AiTags';
        }
        else {
          return false;
        }
      },

      processFinishedAlert(process) {        
        let message = null;
        if(process.action == 'rename') {
          message = `Rename from "${process.detail.topicDisplayName}" to "${process.detail.topicDisplayNameNew}"`;
        }
        else if(process.action == 'merge') {
          message = `Merge "${process.detail.topicDisplayNamesToMerge.join('", "')}" to "${process.detail.topicDisplayName}"`;
        }
        else if(process.action == 'unmerge') {
          message = `Unmerge "${process.detail.topicNames.join('", "')}" from "${process.detail.topicDisplayName}"`;
        }
        else if(process.action == 'blacklist') {
          message = `Blacklist "${process.detail.topicDisplayNames.join('", "')}"`
        }
        else if(process.action == 'unblacklist') {
          message = `Unblacklist "${process.detail.topicDisplayName}"`
        }
        else if(process.action == 'etl' || process.action == 'reload') {
          if(process.detail.fromDate || process.detail.toDate) {
            message = `Update data from ${process.detail.fromDate || 'oldest'} to ${process.detail.toDate || 'latest'}}`;
          }
          else {
            message = "Reload all data";
          }
        }

        let type = 'success';
        let processStatus = process.processStatus;
        if(process.processStatus == "running") {
          type = 'info';
          processStatus = "started";
        }
        else if(process.processStatus == "failed") {
          type = 'error';
          processStatus = "failed";
        }

        setTimeout(() => {
          this.$notify({
            title: `Process ${processStatus}`,
            message: message,
            dangerouslyUseHTMLString: true,
            customClass: "processAlert",
            duration: 8000,
            type: type
          });
        }, 200)
      },

      showProcessListDrawer() {
        this.$root.showProcessListDrawer({visible: true, refreshList: true});
        //this.$router.push({ name: "reload", params: {reload: this.$route.path}});
      }
    }
  }
</script>

<style lang="scss">
.wy-header-menu-platform{
    .el-icon-caret-right {
      position: relative;
      left: 44px !important;
      bottom: 19px !important;
      width: 105px !important;
  }
}
.wy-header-menu-direction, .wy-header-menu-speakers, .wy-header-menu-tasks, .wy-header-menu-languages {
    .el-icon-caret-right {
      position: relative;
      left: 28px !important;
      width: 15px !important;
      margin-left: auto;
  }
}
.nav_top.chatanalytics {
  .nav_top_logo {
    background-image: var(--header-logo);
    // background-position-y: center !important;
    background-size: 220px !important;
    background-position-x: 15px;
    background-position-y: 15px;
    position: relative;
    bottom: 1.9px;
    cursor: pointer;
    background-color: var(--nav-top-background-color);
    // width: 20%;
    width: 299px;
    border-bottom: 1px solid  var(--nav-top-bottom-border-color);
    border-right: 1px solid var(--nav-top-logo-right-border-color);
  }
  .nav_top_calabrio {
    position: relative;
    bottom: 2px;
    cursor: pointer;
    background-color: var(--nav-top-background-color);
    width: 297px;
    min-width: 297px;
    // border-bottom: 1px var(--nav-top-bottom-border-color) solid;
    border-right: 1px var(--nav-top-bottom-border-color) solid;
    color: #1B1F22;
    // font-family: "Helvetica Neue";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: capitalize;
    span {
      padding-left: 25px;
    }
  }
}

.nav_top {
  background-color:#fff;
  text-align: left;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  // min-width: 1390px;
  border-spacing: 0;

  .nav_top_logo {
    min-width: 299px;
    height: 100%;
    padding: 0;  
    background-image: url('../assets/images/app_studio.png');  
    background-size: 178px !important;
    background-repeat: no-repeat;
    background-position-x: 20px;
    background-position-y: 20px;
  }

  .nav_top_bar {
    border-top-width: 0px;
    border-bottom-width: 1px;
    width: fit-content;
    height: 100%;
    padding: 0px 0px 0px 0px;
    min-width: 750px;
    background-color: var(--nav-top-background-color);

    .component.process {
      margin-left: auto;
      color: white;
      padding-top: 20px;
      padding-right: 20px;
      padding-left: 40px;
      font-size: 24px;
      cursor: pointer;
      height: 76px;
      .el-badge__content.is-fixed {
        top: var(--top-menu-alert-dot-top);
        right: var(--top-menu-alert-dot-right);
      }
      .el-badge__content {
        background-color: #CC0000;
        border-radius: 50%;
        color: #FFF;
        display: inline-block;
        font-size: 0px;
        height: 0px;
        line-height: 18px;
        padding: var(--top-menu-alert-dot-size);
        border: unset;
      }
      .process-icon {
        cursor: pointer;
        i.el-icon-bell {
          background-image: var(--header-icon-alert-notification);
          width: 24px;
          height: 21.526px;
          background-repeat: no-repeat;
          color: var(--header-icon-alert-bell-color);
          font-size: 17px;
        }
      }
    }

    > table {
      padding: 0;
      border-spacing: 0;
      width: 100%;
      height: 100%;
      min-width: 1056px;
      > tr {
        vertical-align: bottom;
        
        > td.platform {
          padding-left: 0px;
          width: unset !important;
          padding-bottom: 10px;
          font-weight: normal;
        }
        > td.direction {
          padding-left: 0px;
          width: unset !important;
          padding-bottom: 10px;
          font-weight: normal;
        }
        .component{
          display: inline-block;
          height: 95px;
          border-right: 0px var(--nav-top-right-border-color) solid;
          top: 0px;
          // position: relative;
          vertical-align: middle;
          // padding: 0 10px;
        }
        .component.date-widget {
          top: -1px !important;
          .wy-header-menu-date-filter {
            padding-top: 3px;
            height: 71px !important;
            border-right: 1px var(--nav-top-right-border-color) solid;
            .header-title {
              text-align: left;
              font-size: 14px;
              font-weight: 600;
              color: var(--nav-top-header-title);
              padding-bottom: 2px;
              top: 16px;
              position: relative;
              left: 24px;
            }
            .el-dropdown-date-filter-subtitle {
              text-align: left;
              font-size: 14px;
              width: 222px;
              position: relative;
              left: -21px;
              top: 21px;
              color: var(--nav-top-header-sub-title);
            }
          }
        }
        .component.filtering-widget {
          top: -21px !important;
          .wy-header-menu-filtering {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              top: 23px;
              border: 0px;
              .el-dropdown-title {
                text-align: center;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: 2px;
                left: 23px;
              }
            }
          }
        }
        .component.interactions-filtering-widget {
          position: relative;
          left: 1px;
          top: 0px !important;
          .wy-header-menu-filtering, .wy-header-menu-tasks, .wy-header-menu-languages {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              top: 23px;
              border: 0px;
              margin: 0px 0px 0px 0px !important;
              padding: 2px 0px 0 0px !important;
              .el-dropdown-title {
                text-align: left;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: 2px;
                left: 23px;
              }
              .el-dropdown-subtitle { 
                display: block;
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: fit-content;
                max-width: 125px;
                margin-top: 7px;
                font-weight: 500;
                font-size: 14px;
              }
            }
          }
        }
        .component.tasks-dropdown-widget, .component.languages-widget {
          top: -21px !important;
          .wy-header-menu-filtering, .wy-header-menu-tasks, .wy-header-menu-languages {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              top: 23px;
              border: 0px;
              margin: 0px 0px 0px 0px !important;
              padding: 2px 0px 0 0px !important;
              .el-dropdown-title {
                text-align: left;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: 2px;
                left: 23px;
              }
              .el-dropdown-subtitle { 
                display: block;
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: fit-content;
                max-width: 125px;
                margin-top: 7px;
                font-weight: 500;
                font-size: 14px;
              }
            }
          }
        }
        .component.brands-widget {
          top: -4px !important;
          .wy-header-menu-brand {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              top: 11px;
              .header-title {
                text-align: left;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: -8px;
                left: 24px;
                width: 142px;
                margin-right: -14px;
              }
              .el-dropdown-title {
                font-size: 14px;
                position: relative;
                top: 0px;
                .el-dropdown-subtitle{
                  display: inline-block;
                  padding-right: 7px;
                  max-width: 233px;
                  text-align: left;
                  left: 25px;
                  bottom: 16px;
                  position: relative;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .component.direction-dropdown-widget, .component.speakers-dropdown-widget, .component.direction-dropdown-flows-widget, .component.contactTypes-dropdown-widget {
          top: -4px !important;
          .wy-header-menu-direction,.wy-header-menu-speakers, .wy-header-menu-tasks, .wy-header-menu-languages, .wy-header-menu-contact-type {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              width: 200px;
              text-align: left;
              top: 11px;
              .header-title {
                text-align: left;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: -8px;
                left: 24px;
                width: 181px;
                margin-right: -14px;
              }
              .el-dropdown-title {
                font-size: 14px;
                position: relative;
                // top: 24px;
              }
            }
          }
        }
        .component.platform-dropdown-widget, .component.platform-dropdown-flows-widget {
          top: -4px !important;
          .wy-header-menu-platform {
            border-right: 1px var(--nav-top-right-border-color) solid;
            .wy-header-manu-dropdown.el-dropdown {
              width: 200px;
              text-align: left;
              top: 11px;
              .header-title {
                text-align: left;
                font-size: 14px;
                font-weight: 600;
                color: var(--nav-top-header-title);
                position: relative;
                top: -8px;
                left: 24px;
                width: 181px;
                margin-right: -14px;
              }
              .el-dropdown-title {
                font-size: 14px;
                position: relative;
                // top: 24px;
              }
            }
          }
        }
        .component.account {
          top: 0px !important;
          float: right;
          border-right: 0px;
          // border-left: 1px #C9D3DA solid;
          padding-right: 0;
          &:hover{
            background: rgba(229, 234, 242, 0.09) !important;
          }
          .wy-header-manu-dropdown.el-dropdown {
            top: 2px;
            padding-left: 10px;
            margin-right: 57px !important;
            position: relative;
            right: 0px;
            .header-title {
              font-size: 14px;
              text-align: center;
              font-weight: 600;
              color: var(--nav-top-header-title);
              padding-left: 9px;
            }
          }
        }
        .page{
          display: flex;
          // padding-top: 7px;
          // height: 73.4px;
          height: 73.4px;
          width: 100%;
          border-bottom: 1px var(--nav-top-bottom-border-color) solid;
          padding-left: 0px;
          padding-right: 0px;
          padding-top: 0px;
          min-width: 1285px;
        }
      }
    }

    /* top menu header */
    .wy-header-manu-dropdown {
      display: inline-block;
      .el-dropdown-title {
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        color: #FFF;
        outline: none !important;
        padding: 11px 0px 10px 0px;
        .el-dropdown-subtitle {
          display: inline-block;
          padding-right: 7px;
        }
      }
      background-repeat: no-repeat;
      background-position-x: right;
      background-position-y: 6px;
      background-size: 5px 8px;
      // border: 1px solid white;
      border-radius: 10px;
      opacity: 1;
      padding: 14px 0px 10px 0px;
      top: 12px;
      text-align: right;
      width: 145px;
      margin: 0px 15px;
      .el-dropdown-title {
        color: var(--nav-top-header-sub-title);
      }
      .el-icon-caret-right {
        background-image: var(--header-drop-down-arrow-down);
        background-repeat: no-repeat;
        background-size: 10px 10px;
        background-position-x: 0px;
        background-position-y: 0px;
        width: 11px;
        height: 10px;
        vertical-align: middle;
        position: relative;
        left: 41px;
        bottom: 19px;
      }
      
      .el-icon-caret-right:before {
        content: "";
      }
    }
    .interactions-filtering-widget, .tasks-dropdown-widget, .languages-widget {
      .wy-header-manu-dropdown {
        background-image: unset !important;
      }
    }
    .wy-header-menu-filtering.interactions {
      width: 100%;
      // min-width: 90px;
      max-width: 500px;
      // padding-right: 28px;
      min-width: 145px;
    }
    .wy-header-menu-filtering {
      width: 178px;
      text-align: left;
      height:  74px;
      .wy-header-manu-dropdown {
        height: 13px;
        background-position-x: 18px;
        // background-position-y: 9px;
        background-position-y: 21px;
        background-repeat: no-repeat;
        // display: -webkit-inline-box;
        // display: -ms-inline-flexbox;
        // min-width: 121px;
        width: fit-content;
        background-size: 10%;
        background-image: var(--header-icon-plus-filter);
        border: var(--site-font-primary-color) 1px solid;
        // padding: 6px 4px 10px 18px;
        padding: 4px 4px 9px 14px;
        border-radius: 15px;

        .el-dropdown-subtitle {
          display: inline-block;
          padding-right: 0px;
          margin-left: 0px;
          font-size: 12px;
          position: relative;
          top: 0px;
        }
        .el-dropdown-title {
          padding: 0px 0px 0px 0px;
        }
      }
    }
    // .wy-header-manu-dropdown:hover {
    //   background: #EBF4FD 0% 0% no-repeat padding-box;
    // }
    .wy-header-manu-dropdown.opened {
      background-position-y: 8px;
      background-size: 8px 5px;
      .el-dropdown-title {
        color: var(--nav-top-header-sub-title) !important;
        font-weight: 600;
      }
      .el-icon-caret-right:before {
        content: "";
      }
    }
  }
}
.wy-header-platform-menu-panel {
  transition-duration: 0s;
  // -webkit-transition-duration: 0.6s;
  box-shadow: none;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 10px;
  display: inline-block;
  height: fit-content;
  background-color: transparent;
  padding: 0px 0 10px 0;
  margin: 5px 0 0 0;
  top: 10px !important;
  width: auto;
}
.wy-header-direction-menu-panel {
  transition-duration: 0s;
  // -webkit-transition-duration: 0.6s;
  box-shadow: none;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 10px;
  display: inline-block;
  height: fit-content;
  background-color: transparent;
  padding: 0px 0 10px 0;
  margin: 5px 0 0 0;
  top: 10px !important;
  width: auto;
}

@media(max-width: 1955px){
  .wy-header-menu-panel.wy-header-menu-filtering-panel-ca  {
    // left: 301px !important;
    left: var(--site-top-menu-filtering-panel-left) !important;
  }
}

@media(max-width: 1854px) {
  // .wy-header-menu-panel  {
  //   left: 299px !important;
  // }
  .wy-header-menu-panel.wy-header-menu-filtering-panel-ca.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-filtering-panel-left-2310px) !important;
  }
  // .wy-header-menu-panel.wy-header-menu-platforms-panel {
    // left: 612px !important;
    // left: var(--site-top-menu-platforms-panel-left-1854px) !important;
  // }
  
  .wy-header-menu-panel.wy-header-menu-platforms-panel.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-platforms-panel-left) !important;
  }
  .wy-header-menu-panel.wy-header-menu-direction-panel.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-platforms-panel-left) !important;
  }
  .wy-header-menu-panel.wy-header-menu-tasks-panel.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-platforms-panel-left) !important;
  }
  .wy-header-menu-panel.wy-header-menu-speakers-panel.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-platforms-panel-left) !important;
  }
  .wy-header-menu-panel.wy-header-menu-brand-panel.no-date-range-layout {
    // left: 301px !important;
    left: var(--site-top-menu-branding-panel-left);
  }
}

@media(max-width: 1440px) {
  // .wy-header-menu-panel.wy-header-menu-platforms-panel {
  //   left: 299px !important;
  // }
}

@media(max-width: 1555px) {
.nav_top .nav_top_bar  > table > tr .page{
  min-width: 1110px !important;
}
.wy-brand.wy-product-ia, .wy-brand.wy-product-aq {
  .nav_top .nav_top_bar>table {
    min-width: unset !important;
  }
  .nav_top .nav_top_bar>table>tr .page {
    min-width: unset !important;
  }
}

@media(max-width: 2310px) {
  .wy-header-menu-filtering-panel-ca {
    // left: 1128px !important;
    left: var(--site-top-menu-filtering-panel-left-2310px) !important;
  }
  .wy-header-menu-filtering-panel-ca.has-brand {
    // left: 1128px !important;
    left: var(--site-top-menu-filtering-panel-left-show-brand-2310px) !important;
  }
  
}

  .wy-header-menu-account {
    // width: 100px;
    width: 45px;
    .accountHeader {
      // padding-right: 36px !important;
      // left: calc(100% - 247px);
      // position: relative;
      .header-title {
        display: none;
      }
    }
  }
  .nav_top .nav_top_bar .component.process {
    padding-right: 38px;
  }

  .nav_top .nav_top_bar > table > tr .component.account .wy-header-manu-dropdown.el-dropdown {
    width: 45px;
    right: 6px;
  }
  
}
/* top menu popup panel */
.wy-header-menu-panel {
  transition-duration: 0s;
  // -webkit-transition-duration: 0.6s;
  box-shadow: none;
  // background: #FFFFFF 0% 0% no-repeat padding-box;
  // border-radius: 10px;
  display: inline-block;
  height: fit-content;
  -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
  box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
  background-color: var( --nav-top-menu-panel-background-color);
  padding: 0px 0 0px 0;
  margin: 5px 0 0 0;
  top: 9px !important;
  > .popper__arrow {
    display: none !important;
  }
  span.filter-header {
    padding: 0px 15px 0 0;
    font-weight: bold;
    color: #214586;
    font-size: 14px;
    cursor: pointer;
  }
  .dots {
    font-weight: 600;
    font-size: 12px;
  }

  .el-dropdown-menu__item.dropdown-item-header {
    border-bottom: 2px solid #F8F9FA;
  }
  .el-dropdown-menu__item {
    margin: 0px;
    padding: 0px 20px;
    .checkedIcon{
      float: right;
      color: #ffffff;
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #F4F6F8;
    background-color: rgba(229, 234, 242, 0.09);
    .checkedIcon{
      color: #EBF4FD;
    }
  }
  .el-dropdown-menu__item.is-disabled {
    color: #999 !important;
  }
  .el-dropdown-menu__item.selected {
    background-color: var(--top-menu-panel-calendar-text-selected-background-color) !important;
    color: #ffffff  !important;
    .checkedIcon{
      color: #ffffff  !important;
    }
  }
}
.nav-el-icon.el-icon-account {
  width: 14px;
  height: 13px;
  cursor: pointer;
  margin-bottom: 0px;
  // margin-bottom: 14px;
  background-size: 100%;
  background-image: var(--header-icon-profile);
  top: 1px;
  position: relative;
}
// .el-popper[x-placement^=bottom] {
//   margin-top: -10px;
//   margin-left: -50px;
// }
.el-dropdown-menu{
  border: 0 !important;
}
.menu-panel{
  box-shadow: 0px 0px 6px #55596A40 !important;
  background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
  // border-radius: 10px;
  padding: 0px 0 2px 0;
  display: inline-flex;
  width: 100%;
  border-radius: 0 0 5px 5px;
}
.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
.wy-header-menu-date-filter-panel .popper__arrow{
  display: none;
}

.el-notification.processAlert {
  .el-notification__content {
    text-align: left;
  }
}

@keyframes bounce-in {
  0% {
    transform: scale(0.3);
    opacity: 0.0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@media screen and (max-width: 1435px) {
  .wy-header-menu-date-filter-panel.el-dropdown-menu {
    // left: 301px !important;
    left: var(--site-top-menu-filtering-panel-left) !important;
  }
}
</style>
